<script>
  import { Separator } from '../..'
  import Links from './Links'

  export let content
  export let baseText
  export let links = {}

  const { Component: BaseComponent, props: baseProps = {} } = baseText
</script>

{#if Array.isArray(content)}
  {#each content as paragraph, idx}
    <svelte:component this={BaseComponent} {...baseProps}>
      <Links {links} template={paragraph} />
    </svelte:component>
    {#if idx < content.length - 1}
      <Separator key={10} size={Separator.SIZES.MEDIUM} />
    {/if}
  {/each}
{:else}
  <svelte:component this={BaseComponent} {...baseProps}>
    <Links {links} template={content} />
  </svelte:component>
{/if}
